<template>
  <div>
    <v-checkbox
      v-model="isReceiveNotify"
      :label="$t('Setting.App.NotifyNewTask')"
      hide-details
    />
    <br>
    <v-btn
      color="primary"
      @click="updateSetting"
    >
      {{ $t('Setting.Email.UpdateSetting') }}
    </v-btn>
  </div>
</template>

<script>

import notificationSettingApi from '@/api/hr/notificationSetting'
import { globalModule } from '@/store/moduleName'

export default {
  data: () => ({
    isReceiveNotify: false
  }),
  created () {
    notificationSettingApi.getConfig(resp => {
      if (resp.status === 201 || resp.status === 200) {
        if (resp.data) {
          this.isReceiveNotify = resp.data.isReceivePushNotification
        }
      }
    })
  },
  methods: {
    updateSetting () {
      notificationSettingApi.updateConfig(this.isReceiveNotify, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Message.Action.UpdateSuccess'))
        }
      })
    }
  }
}
</script>
